import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrandSection = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#0a0a0a] py-20 px-6 md:px-10 xl:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-white/8">
          <div className="relative h-72 lg:h-auto min-h-[360px]">
            <img
              src="https://readdy.ai/api/search-image?query=elegant%20whisky%20pouring%20glass%20amber%20liquid%20dark%20background%20luxury%20spirits%20close%20up%20dramatic%20lighting%20premium%20scotch%20whisky%20professional%20photography%20golden%20tones&width=700&height=500&seq=brand-img&orientation=landscape"
              alt="Ma Gádeni - Destilados Premium"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0a0a0a]/60" />
          </div>
          <div className="bg-[#111111] p-10 md:p-14 flex flex-col justify-center">
            <p className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase mb-4 font-medium">{t('brand_label')}</p>
            <h2
              className="text-3xl md:text-4xl font-light text-white mb-6 leading-snug"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t('brand_title_1')}<br />{t('brand_title_2')}<br />
              <span className="text-[#c9a84c]">{t('brand_title_3')}</span>
            </h2>
            <p className="text-white/50 text-sm font-light leading-relaxed mb-6">
              {t('brand_desc_1')}
            </p>
            <p className="text-white/40 text-sm font-light leading-relaxed mb-10">
              {t('brand_desc_2')}
            </p>
            <div className="flex flex-wrap gap-8 mb-10">
              {[
                { key: 'brand_authenticity', icon: 'ri-shield-check-line' },
                { key: 'brand_rarity', icon: 'ri-star-line' },
                { key: 'brand_curation', icon: 'ri-award-line' },
              ].map(item => (
                <div key={item.key} className="flex items-center gap-2">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${item.icon} text-[#c9a84c] text-base`}></i>
                  </div>
                  <span className="text-white/60 text-xs tracking-widest uppercase">{t(item.key)}</span>
                </div>
              ))}
            </div>
            <Link
              to="/our-story"
              className="self-start flex items-center gap-2 text-[#c9a84c] text-xs tracking-widest uppercase font-medium hover:gap-3 transition-all"
            >
              {t('brand_link')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandSection;
